<template>
    <div v-if="color" class="def-colors">
        <h6
            v-if="color.title"
            class="def-colors__title">
            {{ color.title }}
        </h6>
        <div
            class="def-colors__items"
        >
            <a
                v-for="item in color.items"
                :href="item.detailPage"
                :class="{ 'def-colors__item_active' : item.active }"
                :style="`color: ${ item.displayValue }`"
                @click.prevent="$emit('changeColor', item)"
                class="def-colors__item"
            ></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DefColors',
    props: {
        result: {
            type: Object,
        },
    },
    computed: {
        color() {
            return this.result?.matrix?.COLOR_METALL;
        }
    }
}
</script>

<style lang="scss" scoped>
.def-colors{
    &__title{
        font-weight: 500;
        font-size: rem(10);
        color: var(--color-dark-grey);
        margin-bottom: 8px;
    }
    &__items{
        display: grid;
        grid-auto-flow: column;
        grid-column-gap: 16px;
        justify-content: flex-start;
        padding: 3px;
    }
    &__item{
        display: block;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        position: relative;
        background-color: currentColor;
        &:before{
            content: '';
            position: absolute;
            top: -3px;
            right: -3px;
            bottom: -3px;
            left: -3px;
            border-radius: 50%;
            border: 1px solid transparent;
            transition: .2s linear border-color;
        }
        &_active{
            &:before{
                border-color: currentColor;
            }
        }
    }
}
</style>